// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__n6PES","container":"styles_container__DvEPi","popup":"styles_popup__Z1SMY"};